<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Tasks" class="pt-1">
          <div slot="no-body" class="mt-4">
            <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
              class="user-list-filters mb-8" :collapse-action="true">
              <div class="vx-row">
                <div class="vx-col md:w-1/5 sm:w-full w-full">
                  <label class="text-sm opacity-100 text-bold">General</label>

                  <vs-input type="search" placeholder="Search.." v-model="filters['search']"
                    class="mb-4 md:mb-0 w-full" />
                </div>
                <div class="vx-col md:w-1/5 sm:w-full w-full">
                  <label class="text-sm opacity-100 text-bold">Status</label>
                  <v-select :clearable="true" placeholder="" v-model="filters['status']"
                    :options="statuses" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                </div>
                 <div class="vx-col md:w-1/5 sm:w-full w-full">
                  <label class="text-sm opacity-100 text-bold">Frequency</label>
                  <v-select :clearable="true" placeholder="" v-model="filters['frequency']"
                    :options="frequencies" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                </div>
                 <div class="vx-col md:w-1/5 sm:w-full w-full">
                  <label class="text-sm opacity-100 text-bold">Departments</label>
                  <v-select :clearable="true" placeholder="" v-model="filters['departments']"
                    :options="departments" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name"
                    :reduce="dept => dept.id" multiple :closeOnSelect="false"></v-select>
                </div>
                  <div class="vx-col md:w-1/5 sm:w-full w-full">
                    <label class="text-sm opacity-100 text-bold">Staff</label>
                    <v-select :clearable="true" v-model="filters['staff']" name="assignee" placeholder="" label="name" :reduce="option => option.id"
                      :options="staffs" multiple :closeOnSelect="false" :searchable="true" :key="'staff-dropdown'" @search="onSearch" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template slot="no-options">
                      type to search staff
                    </template></v-select>
                  </div>
                   <!-- <div class="vx-col md:w-1/5 sm:w-full w-full">
                  <label class="text-sm opacity-100 text-bold">Completed by</label>
                  <v-select :clearable="true" v-model="filters['completed-by']" name="assignee" placeholder="" label="name" 
                    :options="staffs" multiple :closeOnSelect="false" :searchable="true" :key="'staff-dropdown'" @search="onSearch" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                   <template slot="no-options">
                    type to search staff
                  </template></v-select>
                </div> -->
              </div>
              <div class="vx-row mt-5">
                <div class="vx-col w-full ml-auto">
                  <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                    v-on:click="filters = {}">CLEAR</vs-button>
                </div>
              </div>
            </vx-card>
            <!-- tasks Table -->
            <vs-table id="task-list-table" :data="tasks" stripe class="table-dark-inverted table-auto vs-con-loading__container"  >
              <template slot="thead">
                <vs-td>Code</vs-td>
                <vs-th>Task</vs-th>
                <vs-th>Template</vs-th>
                <vs-th>Users</vs-th>
                <vs-th>Departments</vs-th>
                <vs-th>Due Date</vs-th>
                <vs-th>Status</vs-th>
                <vs-th class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="task in data" :key="task.id">
                  <vs-td>{{ task.code }}</vs-td>
                  <vs-td>{{ task.scheduled_task_schedule.name }}</vs-td>
                  <vs-td>{{ task.scheduled_task_schedule.scheduled_task_template.name }}</vs-td>
                  <vs-td>
                    {{ getStaffNames(task)}}
                  </vs-td>
                  <vs-td>
                    {{ getDepartmentNames(task) }}
                  </vs-td>
                  <vs-td>{{ task.due_date }}</vs-td>
                  <vs-td>{{ task.status }}</vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="Complete Task" position="top">
                        <vs-button class="mr-2" @click.stop="onClickViewTaskInstance(task)" size="small" color="primary"
                          type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"
            ></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
  </div>

</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import profile from '@/apis/profile.js'
const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');
const DepartmentsRepository = RepositoryFactory.get('departments')
const DropDownRepository = RepositoryFactory.get('drop_down');
const StaffRepository = RepositoryFactory.get('staff')
import vSelect from "vue-select";
import Filter from '@/mixins/filter';
import {defaultPagination, perPageList} from "@/constants/config";
export default {
  name: "task-instance",
  data() {
    return {
      tasks: [],
      filters: {},
      meta:{},
      page : 1,
      total: 0,
      current_user: {},
      perPage: defaultPagination,
      descriptionItems: perPageList,
      frequencies:[],
      departments:[],
      allocations:[],
      statuses: [],
      staffs:[]
    };
  },
  mixins:[ Filter ],
  components: {
    'v-select': vSelect,
  },
  methods: {
    async fetchTasks() {
      await this.$vs.loading({
        container: '#task-list-table',
        scale: 0.45
      })
        
      try {
        const response = await ScheduledTasksRepository.getTaskInstances(this.filterQuery, this.perPage, this.page);
        this.tasks = response.data.data;
        this.meta = response.data.meta
        this.$vs.loading.close('#task-list-table > .con-vs-loading')
      } catch (error) {
        console.error("Error fetching tasks:", error);
        this.$vs.loading.close('#task-list-table > .con-vs-loading')
      }
      
 
    },
    onClickViewTaskInstance(task) {
      this.$router.push({path: `/pages/task-instance/${task.id}`})
    },
    filterQueryUpdate() {
    this.fetchTasks()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleChangePage(page) {
      this.page=page;
      this.fetchTasks()
    },
    async getFrequencies() {
      try {
        const { data } = await ScheduledTasksRepository.frequencies();
        this.frequencies = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load frequencies:", err);
      }
    },
    async getAllocations() {
      try {
        const { data } = await ScheduledTasksRepository.allocations();
        // create a new array so Vue detects the change
        this.allocations =data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load allocations:", err);
      }
    },
    async getStatuses() {
      try {
        const { data } = await ScheduledTasksRepository.getTaskStatuses();
        // create a new array so Vue detects the change
        this.statuses =data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load allocations:", err);
      }
    },
     async getDepartments() {
      const { data } = await DepartmentsRepository.get(' ', '', '', '')
      this.departments = data.data
    },
    searchStaff: _.debounce(async (loading, search, vm) => {
      const { data } = await DropDownRepository.getStaffList(`filter[search]=${search}`)
      vm.staffs = data.data
      loading(false);
    }, 350),
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      }
    },
      async getCurrentUser() {
        try {
                const { data } = (await profile.getCurrentUser()).data
                this.current_user = data
            } catch (error) {
               console.error("Failed to set user:", error);
            }
    },
    async getCurrentUserDept(id){
        const { data } = await StaffRepository.getStaff(id)
        this.current_user = data.data
    },
    getStaffNames(task) {
      const staff = task.staff;
      return staff && staff.length ? staff.map(i => i.name).join(', ') : '—';
    },
    getDepartmentNames(task) {
      const depts = task.departments;
      return depts && depts.length ? depts.map(i => i.name).join(', ') : '—';
    }
  },
  async created() {
      // Now the getter will have the value
      await this.getDepartments();
      await this.getCurrentUser();
      // await this.getCurrentUserDept(this.current_user.id)
      this.staffs = [{id:this.current_user.id, name:this.current_user.name, email: this.current_user.email}];
      if (this.filters === null) {
      this.$set(this, 'filters', {
        staff: [this.$store.getters.currentUserId],
        departments: this.current_user.departments
          ? this.current_user.departments.map(x => x.id)
          : []
      });
      this.setFilterId('task_instance',['search','status','frequency','departments','staff'])
    }
    //  this.$nextTick(() => {
    //     this.filterQuery = `filter[staff]=${this.current_user.id}`;
    //       if(this.filters.departments.length > 0){
    //     this.filterQuery += `&filter[departments]=${this.current_user.departments.map((x) => x.id)}`
    //   }
      // });
    
   
      // await this.fetchTasks();
      await this.getFrequencies();
      await this.getAllocations();
    
      await this.getStatuses();
    
     
  },
    watch: {
    page(){
      this.fetchTasks()
    },
    perPage() {
      this.fetchTasks()
    }
  },
 
};
</script>

